<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";
import VSelectWithBlockLabel from "../../Form/Survey/VSelectWithBlockLabel.vue";
import VInputReadonlyWithBlockLabel from "../../Form/Survey/VInputReadonlyWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination:
        answers?.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination,
    did_you_take_a_direct_or_connecting_flight_to_sabah:
        answers?.did_you_take_a_direct_or_connecting_flight_to_sabah,
    arrival_from_which_airport: answers?.arrival_from_which_airport,
    which_airline_did_you_board_on_to_enter_sabah:
        answers?.which_airline_did_you_board_on_to_enter_sabah,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination"
                        v-model:value="
                            form.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination
                        "
                        :label="
                            surveyFields[
                                'which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>

                <template
                    v-if="
                        'By Air' ==
                        form.which_of_the_following_entry_point_did_you_go_through_to_reach_your_destination
                    "
                >
                    <div class="mb-3">
                        <VInputReadonlyWithBlockLabel
                            elId="did_you_take_a_direct_or_connecting_flight_to_sabah"
                            v-model:value="
                                form.did_you_take_a_direct_or_connecting_flight_to_sabah
                            "
                            :label="
                                surveyFields[
                                    'did_you_take_a_direct_or_connecting_flight_to_sabah'
                                ]?.name
                            "
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-3">
                        <VInputReadonlyWithBlockLabel
                            elId="arrival_from_which_airport"
                            v-model:value="form.arrival_from_which_airport"
                            :label="
                                surveyFields['arrival_from_which_airport']?.name
                            "
                            :isPlainText="false"
                        />
                    </div>
                    <div class="mb-3">
                        <VInputReadonlyWithBlockLabel
                            elId="which_airline_did_you_board_on_to_enter_sabah"
                            v-model:value="
                                form.which_airline_did_you_board_on_to_enter_sabah
                            "
                            :label="
                                surveyFields[
                                    'which_airline_did_you_board_on_to_enter_sabah'
                                ]?.name
                            "
                            :isPlainText="false"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
